var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoId = function SvgIcoId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "14px",
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_id")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_Cashy_RegistrationFlow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_id",
    transform: "translate(0.000000, 1.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,-1 C5.56700338,-1 4,0.567003376 4,2.5 C4,4.43299662 5.56700338,6 7.5,6 C9.43299662,6 11,4.43299662 11,2.5 C11,0.567003376 9.43299662,-1 7.5,-1 Z M7.5,1 C8.32842712,1 9,1.67157288 9,2.5 C9,3.32842712 8.32842712,4 7.5,4 C6.67157288,4 6,3.32842712 6,2.5 C6,1.67157288 6.67157288,1 7.5,1 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56440029,7.16375389 L12.617311,7.78727861 C13.4476215,7.91501869 14.1096049,8.54802426 14.2743579,9.37178973 L15,13 L0,13 L0.725642053,9.37178973 C0.890395148,8.54802426 1.55237848,7.91501869 2.38268904,7.78727861 L6.43559971,7.16375389 C7.14105005,7.05522307 7.85894995,7.05522307 8.56440029,7.16375389 Z M8.26028592,9.14049729 C7.85717144,9.07847967 7.44836573,9.06607615 7.04297476,9.10328672 L6.73971408,9.14049729 L2.6868034,9.76402201 L2.439,11 L12.56,11 L12.3131966,9.76402201 L8.26028592,9.14049729 Z",
    id: "Rectangle"
  })))));
};
export default SvgIcoId;